import { Component, ElementRef, OnInit, Renderer, ViewEncapsulation, ViewChildren, QueryList} from '@angular/core';
import { UtilService } from 'src/app/shared/services/util.service';
import { HandleRequestService } from 'src/app/shared/services/handle-request.service';
import { APIResponse } from 'src/app/shared/models/api-response';
import { ActivatedRoute } from '@angular/router';
import { Student } from 'src/app/shared/models/student';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-toddler10',
  templateUrl: './toddler10.component.html',
  styleUrls: ['./toddler10.component.css'],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class Toddler10Component implements OnInit {
  @ViewChildren('canvas') canvasElements: QueryList<ElementRef<HTMLCanvasElement>>;
  canvases = [
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
    { brushColor: '#000000', brushSize: 1, isEraser: false, drawing: false, context: null },
  ];

  resultData: any[] = [];
  student: Student;
  isIOS = false;


  defaultData = [
    [], // 1
    ['28362', '71114', '37978', '14772', '21182'], // 2
    ['173.88', '67.32', '791.01', '280.4', '138.8'], // 3
    ['24', '64', '76', '82', '45', '58', '58', '284'], // 4
    ['23387522', '11564070', '51841482', '4380992', '11789850'], // 5
    ['899', '882', '956', '403', '525'], // 6
    ['9675', '4355', '17473', '692', '12343'], // 7
    ['222.2', '503.84', '198.09', '633.74', '673.08'], // 8
    ['61542', '35724', '35910', '8100', '24075'], // 9
    ['39', '36', '90', '16', '36'], // 10
    [], // 11
    [], // 12
    [], // 13
    [], // 14
    ['77202', '13754', '22685', '36154', '20241'], // 15
    ['497.93', '695.19', '773.87', '189.02', '244.75'], // 16
    ['91', '85', '47', '14', '43', '441', '56', '354'], // 17
    ['76714200', '147846762', '37857402', '17693090', '5900955'], // 18
    ['3', '7', '4', '6', '5'], // 19
    ['3844', '4272', '14440', '9717', '3285'], // 20
    ['474.6', '605.28', '188.13', '607.3', '551.51'], // 21
    ['25344', '23722', '12019', '31290', '16915'], // 22
    ['35', '18', '144', '48', '30'], // 23
    [], // 24
    [], // 25
    [], // 26
    ['3', '1', '5', '7', '4', '8', '2', '6'], // 27
    ['32643', '7124', '31987', '12614', '19967'], // 28
    ['723.99', '481.84', '678.28', '724.3', '494.4'], // 29
    ['95', '42', '41', '22', '33', '97', '87', '65'], // 30
    ['28716606', '31586256', '66558704', '20847580', '13688322'], // 31
    ['27', '25', '23', '26', '24'], // 32
    ['14679', '3281', '4408', '6447', '3481'], // 33
    ['182.25', '231.55', '293.62', '174.71', '338.55'], // 34
    ['25424', '25400', '81855', '344774', '279396'], // 35
    ['12', '14', '16', '8', '9'], // 36
    [], // 37
    [], // 38
    [], // 39
    [], // 40
    ['23936', '19969', '66458', '54464', '49832'], // 41
    ['556.69', '530.56', '408.57', '219.89', '296.22'], // 42
    ['93', '664', '82', '80', '55', '36', '22', '56'], // 43
    ['299743428', '65132700', '37509150', '45431806', '12298768'], // 44
    ['16', '21', '17', '15', '19'], // 45
    ['13997', '19176', '9410', '1393', '7506'], // 46
    ['228.62', '661.4', '344.37', '504.27', '764.69'], // 47
    ['13018', '29344', '28704', '20020', '34902'], // 48
    ['128', '76', '560', '452', '494'], // 49
    [], // 50
    [], // 51
    [], // 52
    [], // 53
    ['24059', '12913', '90562', '118403', '61933'], // 54
    ['565.91', '283.11', '829.46', '215.5', '393.31'], // 55
    ['99', '89', '142', '204', '143', '146', '67', '34'], // 56
    ['45400656', '34974763', '38372241', '10799020', '6300327'], // 57
    ['22', '28', '30', '29', '31'], // 58
    ['1393', '20460', '2520', '2858', '7506'], // 59
    ['509.27', '764.99', '377.06', '350.47', '205.76'], // 60
    ['85869', '13824', '60795', '54250', '598104'], // 61
    ['60', '168', '84', '120', '315'], // 62
    [], // 63
    [], // 64
    [], // 65
    [], // 66
    ['99894', '65396', '32536', '98131', '99806'], // 67
    ['233.91', '657.82', '109.39', '344.06', '594.73'], // 68
    ['41', '46', '24', '331', '32', '90', '75', '61'], // 69
    ['24480327', '4233876', '12945064', '9581288', '3592393'], // 70
    ['77', '88', '41', '61', '83'], // 71
    ['16391', '806', '6589', '8174', '8335'], // 72
    ['461.58', '307.03', '768.55', '634.37', '241.38'], // 73
    ['50', '80', '75', '40', '20'], // 74
    ['188', '171', '234', '552', '258'], // 75
    [], // 76
    [], // 77
    [], // 78
    ['5', '4', '6', '3', '9', '4', '4', '8', '5', '2',
      '5', '2', '3', '4', '3', '6', '6', '2', '8'
    ], // 79
    ['91018', '55581', '91444', '90584', '237656'], // 80
    ['326.55', '546.5', '104.62', '273.11', '720.31'], // 81
    ['34', '52', '27', '73', '42', '46', '234', '322'], // 82
    ['17683904', '19572168', '29195712', '58038072', '61756974'], // 83
    ['39', '52', '60', '65', '42'], // 84
    ['4056', '7945', '1729', '15280', '14752'], // 85
    ['896.7', '303.28', '432.51', '932.55', '330.34'], // 86
    ['3/10', '3/20', '1/2', '1/10', '1/4'], // 87
    ['203', '594', '230', '48', '289'], // 88
    [], // 89
    [], // 90
    [], // 91
    ['22', '8', '16', '14', '30', '15', '25', '36', '4', '40', '3', '6', '7', '2', '9', '6', '4', '2', '8', '10',
      '3', '15', '10', '8', '18', '4', '17', '5', '16', '21', '29', '2', '16', '15', '31', '23', '2', '14', '11', '25',
      '16', '19', '28', '7', '35', '19', '3', '11', '11', '22', '22', '28', '40', '10', '50', '14', '13', '6', '21', '27'], // 92
    ['80120', '5942', '99082', '34416', '62815'], // 93
    ['807.44', '370.55', '767.68', '278.19', '533.89'], // 94
    ['87', '68', '79', '35', '80', '67', '202', '86'], // 95
    ['43943354', '12452297', '14189134', '34158404', '11552380'], // 96
    ['22', '6', '7', '13', '9'], // 97
    ['17994', '6955', '2743', '613', '7234'], // 98
    ['500.94', '220.27', '521.53', '210.63', '345.26'], // 99
    ['50', '3', '5', '50', '7', '20', '80'], // 100
    ['380', '132', '282', '48', '88'], // 101
    [], // 102
    [], // 103
    [], // 104
    ['16', '19', '18', '10', '13','13', '9', '12', '34'], // 105
    ['44850', '62082', '28120', '45594', '33335'], // 106
    ['177.16', '314.85', '638.64', '426.65', '517.88'], // 107
    ['358', '5635', '3546', '1234', '1458', '2581', '886', '546'], // 108
    ['5431200', '40932255', '38918064', '29095523', '45413490'], // 109
    ['30', '44', '56', '108', '20'], // 110
    ['17460', '9200', '1310', '12417', '4210'], // 111
    ['360', '811.09', '966.52', '710.17', '520.25'], // 112
    ['165', null, null, '7', '1', '2',
      '4', '1', '2', '68', null, null,
      '6', null, null
    ], // 113
    ['108', '112', '395', '336', '430'], // 114
    [], // 115
    [], // 116
    [], // 117
    [], // 118
    ['38661', '294351', '194963', '80002', '68126'], // 119
    ['929.19', '94.89', '771.81', '626.26', '139.8'], // 120
    ['2122', '783', '1534', '258', '147', '358', '654', '987'], // 121
    ['15473030', '9346218', '10103148', '4331726', '3581952'], // 122
    ['3', '6', '2', '2', '6'], // 123
    ['388', '3409', '10450', '14323', '4373'], // 124
    ['149.4', '152.53', '360.03', '386.12', '822.51'], // 125
    ['20', '80', '20', '25', '20'], // 126
    ['1896', '1359', '1920', '1050', '910'], // 127
    [], // 128
    [], // 129
    [], // 130
  ];
  type = 'toddler10';

  constructor(
    private utilService: UtilService,
    private httpService: HandleRequestService,
    private route: ActivatedRoute,
    private elRef: ElementRef,
    private toastr: ToastrService,
    private renderer: Renderer
  ) { }

  ngOnInit() {
    if (/iPad|iPhone|iPod/.test(window.navigator.userAgent)) {
      this.isIOS = true;
    }

    for (var i = 0; i < 131; i++) {
      this.resultData.push({
        values: [],
        times: null,
        count: 0,
        correctAnswers: 10,
        resultIsIncorrect: [false,false,false,false,false,false,false,false,false,false],
        finished: false
      })
    }
    this.route.data.subscribe(x => {
      if (x.hasOwnProperty('profile')) {
        const response = x.profile as APIResponse;
        this.student = response.data as Student;
      }

      this.httpService.post('/smartpdf/get', {
        type: this.type,
        user_id: this.student._id,
      }).then(
        (res: APIResponse) => {
          if (res.data.smartpdf) {
            this.resultData = res.data.smartpdf.data.result;
          }
          this.canvases.forEach((canvas, index) => {
            if (!canvas.context) {
              canvas.context = this.canvasElements.toArray()[index].nativeElement.getContext('2d');
            }
          });
          this.loadDrawing();
        }, () => {
         
        }
      );

      
    });


  }

  startDrawing(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw(e: TouchEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const event = e.touches[0];
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  startDrawing1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = true;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.beginPath();
    canvas.context.moveTo(x, y);
  }

  draw1(event: MouseEvent, index: number): void {
    const canvas = this.canvases[index];
    if (!canvas.drawing) return;
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const rect = canvasElement.getBoundingClientRect();
    const x = event.clientX - rect.left;
    const y = event.clientY - rect.top;
    canvas.context.lineTo(x, y);
    canvas.context.stroke();
  }

  stopDrawing1(index: number): void {
    const canvas = this.canvases[index];
    canvas.drawing = false;
    canvas.context.closePath();
  }

  saveDrawing(index: number): void {
    this.toastr.info('Saving...');
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const dataURL = canvasElement.toDataURL();
    this.httpService.post('/smartcanvas/update', {
      type: this.type,
      user_id: this.student._id,
      serial: index,
      data: dataURL
    }).then(
      (res: APIResponse) => {
        this.toastr.clear();
        this.toastr.success('Successfully Saved');
      }, () => {
      }
    );
  }

  async loadDrawing() {
    for (var index in this.canvases) {
      this.httpService.post('/smartcanvas/get', {
        type: this.type,
        user_id: this.student._id,
        serial: index
      }).then(
        (res: APIResponse) => {
          if (res.data.smartcanvas) {
            const img = new Image();
            img.onload = () => {
            const canvasElement = this.canvasElements.toArray()[index].nativeElement;
              const context = canvasElement.getContext('2d');
              context.clearRect(0, 0, canvasElement.width, canvasElement.height);
              context.drawImage(img, 0, 0);
            };
            img.src = res.data.smartcanvas.data;
          }
        }, () => {
         
        }
      );

      await this.delay(2000);
    }
    
  }

  backToSavedImage(index: number) {
    this.httpService.post('/smartcanvas/get', {
      type: this.type,
      user_id: this.student._id,
      serial: index
    }).then(
      (res: APIResponse) => {
        if (res.data.smartcanvas) {
          const img = new Image();
          img.onload = () => {
          const canvasElement = this.canvasElements.toArray()[index].nativeElement;
            const context = canvasElement.getContext('2d');
            context.clearRect(0, 0, canvasElement.width, canvasElement.height);
            context.drawImage(img, 0, 0);
          };
          img.src = res.data.smartcanvas.data;
        }
      }, () => {
       
      }
    );
  }

  clearCanvas(index: number): void {
    const canvasElement = this.canvasElements.toArray()[index].nativeElement;
    const context = canvasElement.getContext('2d');
    context.clearRect(0, 0, canvasElement.width, canvasElement.height);
  }

  canvasPropertiesChanges(): void {
    this.canvases.forEach(canvas => {
      if (!canvas.isEraser) {
        canvas.context.strokeStyle = canvas.brushColor;
      }
      canvas.context.lineWidth = canvas.brushSize;
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }


  quastionConfirm(index) {
    this.resultData[index].finished = true;
    if (this.resultData[index].count < 2) {
      this.resultData[index].count++;
      let allCorrect = true;
      for (let i in this.defaultData[index]) {
        if (this.defaultData[index][i] != this.resultData[index].values[i]) {
          allCorrect = false;
        }
      }
      if (!allCorrect && this.resultData[index].count == 1) {
        this.toastr.error('Corrige el resultado en rojo y vuelve a picar. Solo tienes una oportunidad de corregir.');
      }
    }
    this.saveData();
  }
  quastionChange(index) {
    this.resultData[index].finished = false;
    for (let i in this.resultData[index].values) {
      if (this.resultData[index].values[i] == '') {
        this.resultData[index].values[i] = null;
      }
    }
  }

  quastionConfirm1(index) {
    this.resultData[index].finished = true;
    this.saveData();
  }

  clickedNumbers(i, j) {
    if (this.resultData[i].finished && this.resultData[i].count >= 2) {
      return;
    }
    this.resultData[i].finished = false;
    if (this.resultData[i].values[j] == '1') {
      this.resultData[i].values[j] = '0';
    } else {
      this.resultData[i].values[j] = '1';
    }
  }

  correctAnswerCheck(i, j) {
    if (!this.resultData[i].resultIsIncorrect[j] && this.resultData[i].finished){
      if (document.activeElement && document.activeElement !== document.body) {
        this.renderer.invokeElementMethod(
          this.elRef.nativeElement.ownerDocument.activeElement, 'blur');
      }
      this.resultData[i].resultIsIncorrect[j] = true;
      this.resultData[i].correctAnswers--;
      this.saveData();
    }
  }

  saveData() {
    this.toastr.info('Saving...');
    this.httpService.post('/smartpdf/update', {
      type: this.type,
      user_id: this.student._id,
      data: {
        result: this.resultData
      }
    }).then(
      (res: APIResponse) => {
        this.toastr.success('Saved');
      }, () => {
      }
    );
  }
}
